var logo = `
                 _____                      _____ _____                _____ _____
                /\\    \\                    /::::::\\    \\              /::::::\\    \\
               /::\\    \\                  /::::::::\\    \\            /::::::::\\    \\
              /:::/    /                 /:::/--\\:::\\    \\          /:::/--\\:::\\    \\
             /:::/    /                 /:::/   _\\:::\\    \\        /:::/   _\\:::\\    \\
            /:::/____/                 /:::/   /  |:::|    |      /:::/   /  \\:::\\    \\
           /::::\\    \\                /:::/   /   |:::| __ |     /:::/   /   /::::\\    \\
          /::::::\\    \\              /:::/   /   /:::/    /     /:::/   /   /::::::\\    \\
         /:::/\\:::\\    \\            /:::/___/   /:::/    /      |:::|   |  /:::/\\:::\\    \\
         \\::/  \\:::\\    \\           \\:::\\   \\  /:::/    /       |:::|   | /:::/  \\:::\\____\\
          \\/___/\\:::\\    \\ ____      \\:::\\   \\/:::/    /        \\:::\\   \\/:::/    \\::/    /
                 \\:::\\    /\\    \\     \\:::\\  /:::/    /          \\:::\\  /:::/    / \\/____/
                  \\:::\\  /::\\ ___\\     \\:::\\/:::/    /            \\:::\\/:::/    /
                   \\:::\\/:::/    /      \\::::::/    /              \\::::::/    /
                    \\::::::/    /        \\::::/____/                \\::::/____/
                     \\::::/    /          \\:::\\    \\                 \\:::\\    \\
                     /:::/    /            \\:::\\    \\                 \\:::\\    \\
                    /:::/    /              \\:::\\    \\                 \\:::\\    \\
                   /:::/    /                \\:::\\____\\                 \\:::\\____\\
                   \\::/    /                  \\::/    /                  \\::/    /
                    \\/____/                    \\/____/                    \\/____/
`;

module.exports = logo;



// WEBPACK FOOTER //
// ./src/utils/texlogo.js